import { Component, OnInit, ElementRef, Renderer2, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ActionCoCalculatorModel, ActionCoCalculatorMission, ActionCoMissionGroup, ActionCoMissionQuestion, ActionCoMissionPDCGrouped, ActionCoMissionProperty, BObjectModel, ActionCoCollaborateurMission, BObjectBody, PropertyGroup, PropertyData, ActionCoCalculatorTab, Corporation, QueovalItem, ActionCoMissionPDC, TDOPlanDeCharge, QResult, QueovalDik } from '../../../models';
import { HttpService, CoreService, QueovalDateService } from '../../../services';
import { ToastService } from '../../../toast';
import { ActionCoService } from '../action-co-services/action-co.service';
import { ActionCoCalculatorService } from '../action-co-services/action-co-calculator.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { setAlertMNG } from '../../../utilities';
import { map } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
import { BodisplayService } from '../../../bodisplay';
import { BoProperty, IBoProperty } from '../../../models/bodisplay/dynamictags-inline/dynamictags-inline.model';
import { of } from 'rxjs/internal/observable/of';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-calculateur',
  templateUrl: './action-co-calculator.component.html',
  styleUrls: []
})

export class ActionCoCalculatorComponent {//implements OnInit, OnDestroy {
  public ListenMission(): void {
    this.actionCoService.OnMissionAdd();
  }
  public OnSave(): void {
    this.actionCoService.CanTransform();
  }
  constructor(
    protected http: HttpService,
    protected httpClient: HttpClient,
    public indParam: CoreService,
    protected qDateService: QueovalDateService,
    public sanitizer: DomSanitizer,
    public toast: ToastService,
    public actionCoService: ActionCoService,
    private renderer: Renderer2,
    protected modalService: NgbModal,
    private router: Router,
    public calculatorService: ActionCoCalculatorService,
    private cd: ChangeDetectorRef,
    private boService: BodisplayService,
  ) { }
}
